// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import TagConstants from 'constants/TagConstants'

const TagActions = Marty.createActionCreators({
  createTag(tagParams) {
    return this.dispatch(TagConstants.TAG_CREATE, tagParams)
  },

  updateTag(tagId, tagParams) {
    return this.dispatch(TagConstants.TAG_UPDATE, tagId, tagParams)
  },

  deleteTag(tagId) {
    return this.dispatch(TagConstants.TAG_DELETE, tagId)
  },

  pushTag(tag) {
    return this.dispatch(TagConstants.PUSH_TAG, tag)
  },

  addTagsToConversationId(conversationId, tagIds) {
    return this.app.queries.TagQueries.addTagsToConversationId(conversationId, tagIds)
  },

  removeTagsFromConversationId(conversationId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromConversationId(conversationId, tagIds)
  },

  addTagsToCompanyId(companyId, tagIds) {
    return this.app.queries.TagQueries.addTagsToCompanyId(companyId, tagIds)
  },

  removeTagsFromCompanyId(companyId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromCompanyId(companyId, tagIds)
  },

  addTagsToEndUserId(endUserId, tagIds) {
    return this.app.queries.TagQueries.addTagsToEndUserId(endUserId, tagIds)
  },

  removeTagsFromEndUserId(endUserId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromEndUserId(endUserId, tagIds)
  }
})

export default TagActions



// WEBPACK FOOTER //
// ./src/scripts/actions/TagActions.js